import { useExperienceBuilderContext } from "components/ExperienceBuilderEG/context/ExperienceBuilderContext";
import { Button } from "shared";
import { ButtonVariants } from "shared/Button/Button";
import LocationFilters from "../Courses/LocationFilters";
import HotelsList from "./HotelsList";
import DOMPurify from "dompurify";
import GoogleMap from "../GoogleMap";

function Hotels() {
  const { setActiveStep, labels } = useExperienceBuilderContext();

  return (
    <div className="m-courses">
      <div className="u-wrapper">
        <Button
          extraClass="back-btn"
          text="Back"
          variant={ButtonVariants.Naked}
          onClick={() => setActiveStep("courses")}
        />
        <h2 className="a-title__main">{labels.Hotels.Title}</h2>
        <div className="a-title__short-text">
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(labels.Hotels.Description),
            }}
          ></p>
        </div>
      </div>
      <hr className="u-divider" />

      <div className="u-wrapper">
        <div className="m-courses__content">
          <div className="m-courses__content--left">
            <LocationFilters />
            <HotelsList />
          </div>
          <div>
            <GoogleMap />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hotels;
